import React from 'react';

const VideoContext = React.createContext('video');

export default VideoContext;
export { VideoContext };
